import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const TAG_API_URL = `${API_HOST}/api/tag`;
const TAG_MEMBER_LIST_API_URL = `${TAG_API_URL}/tagMemberList`;

function* createTag() {
  yield takeEvery(actions.CREATE_TAG, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], TAG_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_TAG_ENDED });
    }
  });
}

function* updateTag() {
  yield takeEvery(actions.UPDATE_TAG, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], TAG_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_TAG_ENDED });
    }
  });
}

function* deleteTags() {
  yield takeEvery(actions.DELETE_TAGS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], TAG_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_TAGS_ENDED });
    }
  });
}

function* searchTags() {
  yield takeEvery(actions.SEARCH_TAGS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${TAG_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_TAGS_ENDED });
    }
  });
}

function* searchTagMemberListBatchRow() {
  yield takeEvery(actions.SEARCH_TAG_MEMBER_LIST_BATCH_ROW, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${TAG_MEMBER_LIST_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_TAG_MEMBER_LIST_BATCH_ROW_ENDED });
    }
  });
}

function* searchInvalidTagMemberListBatchRow() {
  yield takeEvery(actions.SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${TAG_MEMBER_LIST_API_URL}/invalidTag?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW_ENDED });
    }
  });
}

function* deleteTagMemberListBatchRows() {
  yield takeEvery(actions.DELETE_TAG_MEMBER_LIST_BATCH_ROWS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], TAG_MEMBER_LIST_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_TAG_MEMBER_LIST_BATCH_ROWS_ENDED });
    }
  });
}

function* addMemberToTagMemberList() {
  yield takeEvery(actions.ADD_MEMBER_TO_TAG_MEMBER_LIST, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${TAG_MEMBER_LIST_API_URL}`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.ADD_MEMBER_TO_TAG_MEMBER_LIST_ENDED });
    }
  });
}

function* addMemberListToTagMemberList() {
  yield takeEvery(actions.ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${TAG_MEMBER_LIST_API_URL}/memberList`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST_ENDED });
    }
  });
}

function* deleteMembersFromMemberList() {
  yield takeEvery(actions.DELETE_MEMBERS_FROM_MEMBER_LIST, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${TAG_MEMBER_LIST_API_URL}/memberList`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_MEMBERS_FROM_MEMBER_LIST_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createTag),
    fork(updateTag),
    fork(deleteTags),
    fork(searchTags),
    fork(searchTagMemberListBatchRow),
    fork(deleteTagMemberListBatchRows),
    fork(addMemberToTagMemberList),
    fork(addMemberListToTagMemberList),
    fork(deleteMembersFromMemberList),
    fork(searchInvalidTagMemberListBatchRow),
  ]);
}
